$(document).ready(function () {
    $('#savefile').on('show.bs.modal', function () {
        var modal = $(this);
        var assignment_title  = $(modal).find('select[name="title_id"]');
        var custom_title      = $(modal).find('.custom_title');
        var upload_form       = $(modal).find('form');
        var duplicate_warning = $(modal).find('.no-duplicates-allowed');

        $(duplicate_warning).hide();

        $(custom_title).hide();

        $(assignment_title).change(function () {
            if ($(assignment_title).val() == 'custom') {
                $(custom_title).show();
            } else {
                $(custom_title).hide();
            }

            /*
             * Show the warning about duplicate submissions if the student
             * is about to submit to an assignment that doesn't allow
             * duplicate submissions
             */
            if ($(this).find(':selected').data('duplicates') == 0) {
                $(duplicate_warning).show();
            } else {
                $(duplicate_warning).hide();
            }
        });
        $.validator.addMethod('checkTitle', function (value, element, param) {
            if (value === '0') {
                return false;
            }

            return true;
        }, 'Please select an assignment');
        $(upload_form).validate({
            ignore: ':hidden, [contenteditable="true"]:not([name])',
            debug: false,
            errorClass: 'danger',
            rules: {
                title_id: { required: true },
                custom_title: {
                    required: {
                        depends: function () {
                            return $('select[name="title_id"]').val() === 'custom';
                        },
                    },
                },
                userfile: { required: true },
                group: { required: true },
            },
            submitHandler: function (form) {
                form.submit();
            },
        });
    });

    $('#eportfolio-feedback').on('show.bs.modal', function (e) {
        var file = $(e.relatedTarget).data('file');
        $('.file-title').empty().append(file.title);
        $('.feedback-date').empty().append('<small>Posted:' + dayjs(parseInt(file.feedback.createddate) * 1000).format(LONGDATE + ' ' + TIME) + '</small>');
        $('.feedback-replace').empty().append(file.feedback.feedback.replace('\n', '<br>'));
    });
});
